export const menuLinks = {

  customerOrders: "/orders",
  customerOrderDetails: "/orderdetails",
  creditNote: "/creditnote",
  creditNoteDetails: "/creditnotedetails",


  importLogs: "/importlogs",
  importLogsDetails: "/importlogsdetails",

  configs: "/configs",
  users: "/users",
  roles: "/roles",
  localFiles: "/localfiles",
  templates: "/templates",
  d2cOrder: "/d2corder",

  dashboard: "/dashboard",  
  singelOrder: "/singelorder",
  
};

export const notifyMessages = {
  requiredField: "Field required",
  errorAccured: "An error occurred. Please try again!",
  success: "Request completed",
  uploadFile: "Please upload a file"
};

export const LAST_SELECTED_COUNTRY_HEADER = 'Last-Selected-Country-Id';

export const primaryColor = "#011e41";

export const twoColorsTone = {
  '0%': '#108ee9',
  '100%': '#87d068',
};

export const drawerWidth = 550;
export const drawerWidth750 = 750;
export const dateFormat = 'DD/MM/YYYY';
export const dateFormatIso = 'YYYY-MM-DD';

export const tablePageSize = 20;
export const formItemLayout = { labelCol: { span: 24 }, wrapperCol: { span: 24 } };

export const applicationCode = {
  customerOrder: "COM",
  bulkImport: "BIT",
  fondoSvalutazione: "FSC"
};


export const MAX_FILE_SIZE_MB = 50;
export const ALLOWED_EXTENSIONS = ['.xls', '.xlsx', '.csv'];
export const ALLOWED_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv'
];

export const orderUploadStatus = {
  success: "Success",
  failed: "Failed",
  inProgress: "InProgress",
  pending: "Pending",
  partiallyProcessed: "PartiallyProcessed",
  completed: "Completed"
};

export const selectOptionsTypes = {
  customerGroupText: "customerGroupText",
  apO_DP_Grp_Name: "apO_DP_Grp_Name",
  soldTo: "soldTo",
  shipTo: "shipTo",
  material: "material",
  model: "model",
  productGroup: "productGroup",
  materialType: "materialType",
  storageLocation: "storageLocation",
  plant: "plant",
  orderType: "orderType",
  billToParty: "billToParty",
  billingBlock: "billingBlock",
  deliveryBlock: "deliveryBlock",
  division: "division",
  orderReason: "orderReason",
  paymentTerms: "paymentTerms",
  conditionType: "conditionType",
  distributionChannel: "distributionChannel",
  purchasedOrderType: "purchasedOrderType",
  salesOrganization: "salesOrganization"
};

export const multiOrderUpdateFields = {
  material: "material",
  address: "address",  
  city: "city",
  region: "region",
  postalCode: "postalCode"
};

export const orderStatusesCode = {
  sendToRpa: "2",
  new:"1"
};

export const rpaTemplateTypesCode = {
  rpaCS: "1",
  rpaD2C: "2"
};

export const orderTypesCode = {
  zqs: "ZQS",
  zso: "ZSO",
  zsa: "ZSA"
};

export const logTypesCode = {
  order: "1",
  orderD2C: "2",
  creditNote: "3",
  localFiles: "4"
};

export const logTypesNames = {
  localFiles: "Local Files"
};
